import { VehicleEventsModel, VehicleModel, VehicleTypesSpeedModel } from "@core/services/api.service";

//Load vehicles
export class LoadVehiclesAction {
    static readonly type = '[Vehicles] Load Vehicles';

    constructor(public payload: { searchTerm: string }) { }
}

export class LoadVehiclesSuccessAction {
    static readonly type = '[Vehicles] Load Vehicles Success';

    constructor(public payload: { vehicles: VehicleModel[] }) { }
}

export class LoadVehiclesFailAction {
    static readonly type = '[Vehicles] Load Vehicles Fail';
}
//end

//start
export class GetVehicleByIdAction {
  static readonly type = '[Vehicle] Get Vehicle By ID';

  constructor(public Id: number) { }
}

export class GetVehicleByIdSuccessAction {
  static readonly type = '[Vehicle] Get Vehicle By ID Success';

  constructor(public payload:{ vehicle: VehicleModel }) { }
}

export class GetVehicleByIdFailAction {
  static readonly type = '[Vehicle] Get Vehicle By ID Fail';
}
//end

//start
export class AddVehicleAction {
    static readonly type = '[Vehicle] Add vehicle by Registration number';

    constructor(public regNumber: string, public id: number) { }
  }

  export class AddVehicleSuccessAction {
    static readonly type = '[Vehicle] Add vehicle by Registration number Success';

    constructor(public payload: { vehicle: VehicleModel }) { }
  }

  export class AddVehicleFailAction {
    static readonly type = '[Vehicle] Add vehicle by Registration number Fail';
  }
  //end

  //start
  export class GetVehicleEventsAction {
    static readonly type = '[Vehicle] Get vehicle events by tourId';

    constructor(public Id: number) { }
  }

  export class GetVehicleEventsSuccessAction {
    static readonly type = '[Vehicle] Get vehicle events by tourId Success';

    constructor(public payload: { vehicleEvents: VehicleEventsModel[] }) { }
  }

  export class GetVehicleEventsFailAction {
    static readonly type = '[Vehicle] Get vehicle events by tourId Fail';
  }
  //end

  //start
  export class GetVehicleLocFromEventAction {
    static readonly type = '[Vehicle Loc] Get vehicle location events by tourId';

    constructor(public Id: number) { }
  }

  export class GetVehicleLocFromEventSuccessAction {
    static readonly type = '[Vehicle Loc] Get vehicle locationevents by tourId Success';

    constructor(public payload: { vehicleEvent: VehicleEventsModel }) { }
  }

  export class GetVehicleLocFromEventFailAction {
    static readonly type = '[Vehicle Loc] Get vehicle locationevents by tourId Fail';
  }
  //end

  //start
  export class GetVehicleSpeedByTypeAction {
    static readonly type = '[Vehicle Speed] Get vehicle speed by vehicle type';

    constructor(public VehicleType: string) { }
  }

  export class GetVehicleSpeedByTypeSuccessAction {
    static readonly type = '[Vehicle Speed] Get vehicle speed by vehicle type Success';

    constructor(public payload: { vehicleTypesSpeed: VehicleTypesSpeedModel }) { }
  }

  export class GetVehicleSpeedByTypeFailAction {
    static readonly type = '[Vehicle Speed] Get vehicle speed by vehicle type Fail';
  }
  //end
